import { render, staticRenderFns } from "./selectAfterSaleOrder.vue?vue&type=template&id=67cb834d&scoped=true&"
import script from "./selectAfterSaleOrder.vue?vue&type=script&lang=js&"
export * from "./selectAfterSaleOrder.vue?vue&type=script&lang=js&"
import style0 from "./selectAfterSaleOrder.vue?vue&type=style&index=0&id=67cb834d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb834d",
  null
  
)

component.options.__file = "selectAfterSaleOrder.vue"
export default component.exports